<template>
  <div class="app-container">

    <div class="row">
      <div class="col-3"></div>
      <div class="text-center col-6">
        <h5 class="no-slab m-0 text-muted"><b>Leyenda de fechas de exámenes</b></h5>      
        <p>
          <template v-for="group in groupsDegrees">
            <span class="calendar-label" v-bind:style="{backgroundColor:group.color, borderColor:group.color, marginRight: '5px'}">
              {{group.name}}
            </span>
          </template>
        </p>
        <p>
          🏫 <strong>Exclusivo para centros</strong>
        </p>
        <p>
          🎓 <strong>ULPGC</strong> &nbsp; &nbsp; - &nbsp; &nbsp;  📝🔍 <strong>Simulacro</strong>
        </p>
        <p>
          🚫 <strong>Convocatoria cerrada o plazas ocupadas</strong>
        </p>
      </div>
      <div class="col-3"></div>
    </div>

    <full-calendar ref="fullCalendar" :options="calendarOptions" />
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      calendarOptions: {
        customButtons: {
          prevMonth: {
            icon: 'fc-icon fc-icon-chevron-left',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              this.calendarOptions.events = [];
              calendarApi.prev();
              this.fetchCourses(calendarApi.getDate());
            },
          },
          nextMonth: {
            icon: 'fc-icon fc-icon-chevron-right',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              this.calendarOptions.events = [];
              calendarApi.next();
              this.fetchCourses(calendarApi.getDate());
            },
          },
          dateNow: {
            text: 'Hoy',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi();
              this.calendarOptions.events = [];
              calendarApi.today();
              this.fetchCourses(calendarApi.getDate());
            },
          },
        },
        showNonCurrentDates: false,
        views: {
          dayGridMonth: {
            dayMaxEvents: 5,
          },
        },
        fixedWeekCount: false,
        headerToolbar: {
          left: 'prevMonth,nextMonth dateNow',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,dayGridDay',
        },


        locale: esLocale,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        events: [],
        firstDay: 1,
      },
      courses: [],
      current_center_id: 0,
      groupsDegrees: [],
      actualDate: new Date(),
      eventClick: this.handleEventClick,
    };
  },
  created() {
    this.getCurrentCenter();
    this.fetchCourses(0);
    this.fetchGroupsdegrees();
  },
  methods: {
    getCurrentCenter() {
      axios.get('/current-center')
      .then(res => {
        this.current_center_id = res.data
      })
      .catch(e => {
        console.log(e);
      })
    },
    fetchGroupsdegrees() {
      axios.get('/groupdegrees-json')
      .then(res => {
        this.groupsDegrees = res.data;
      })
      .catch(e => {
        console.log(e.response);
      })
    },
    fetchCourses(date) {
      this.setCalendarDate(date);
      axios.get('/calendar-courses-json', {
        params: {
          calendar_date: date,
        }
      })
      .then(res => {
        this.courses = res.data;
        this.setEvents();
      })
      .catch(e => {
        console.log(e.response);
      })
      this.setEvents();
    },
    setCalendarDate(date) {
      if (date !== 0 && date.getMonth() === this.actualDate.getMonth()) {
        this.$refs.fullCalendar.getApi().gotoDate(this.actualDate);
      }
    },
    setEvents() {
      const events = [];
      const today = new Date();
      this.courses.forEach((course) => {
        var url = ''
        if(( course.for_center && course.user_center_id === this.current_center_id ) || !course.for_center){
          url = (new Date(course.date_finish) >= today && !course.is_full) ? (course.user_center ? 'formulario-de-matricula-centro/' : 'formulario-de-matricula/') + course.id : '' 
        }
        events.push({
          'title': ((new Date(course.date_finish) < today || course.is_full) ? '🚫' : '') + (course.for_center ? '🏫 ' : course.university ? '🎓' : course.drill ? '📝🔍' : '') + course.name, 
          'date': course.date_start,
          'id': course.id,
          'borderColor': course.group_color,
          'backgroundColor': course.group_color,
          'textColor': '#000000',
          'start': course.date_start,
          'display': 'block',
          'url': url,
        }); 
      });
      this.calendarOptions.events = events;
    },
    handleEventClick(info) {
      if (info.event.url) {
        window.open(info.event.url);
      }
    },
  },
};
</script>
